import type { FC } from 'react';

import { SECTION_IDS } from '@/features/home/constants/home.constants';
import type { FaqItem } from '@/types/home.types';

interface FaqSectionProps {
  items: FaqItem[];
}

// <details> gives us an accessible accordion with zero state, which keeps this a
// pure presentational component (root CLAUDE.md §2.4).
const FaqSection: FC<FaqSectionProps> = ({ items }) => (
  <section id={SECTION_IDS.faq} className="scroll-mt-20 bg-[var(--color-surface-muted)]">
    <div className="mx-auto w-full max-w-3xl px-5 py-20 md:px-8">
      <h2 className="font-display text-3xl font-extrabold text-[var(--color-ink)] md:text-4xl">
        Questions students ask
      </h2>

      <div className="mt-10 flex flex-col gap-3">
        {items.map((item) => (
          <details
            key={item.question}
            className="group rounded-2xl border border-[var(--color-divider)] bg-white px-6 py-5 [&_summary::-webkit-details-marker]:hidden"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-display text-base font-bold text-[var(--color-ink)]">
              {item.question}
              <span
                aria-hidden
                className="text-xl leading-none text-[var(--color-ink-soft)] transition-transform group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <p className="mt-3 text-sm leading-relaxed text-[var(--color-ink-muted)]">
              {item.answer}
            </p>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default FaqSection;
